// Add at top of file
const TRANSLATED_SLUGS = {
  women: document.body.dataset.womenPageSlug || 'women',
  men: document.body.dataset.menPageSlug || 'men',
  dg: document.body.dataset.dgPageSlug || 'dolce-gabbana'
};

/***********************************************************
 * 1) POST HELPER
 ************************************************************/
async function postData(url = '', data = {}) {
    const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    });
    return response.json();
}

let isUpdating = false; // Prevents multiple cart updates at the same time

/***********************************************************
 * 2) HELPER: Detect if Root or Localized Root
 ************************************************************/
function isRootOrLocalizedRoot() {
  const parts = window.location.pathname.split('/').filter(Boolean);

  // "/" => no segments
  if (parts.length === 0) {
    return true;
  }

  // "/fr", "/en", "/en-us", "/fr-ca", etc. => single segment
  // If you have 3-letter codes, use ^[a-z]{2,3}(-[a-z]{2,3})?$
  if (parts.length === 1) {
    return /^[a-z]{2}(-[a-z]{2})?$/.test(parts[0]);
  }

  // More than one path segment => not a root/localized root
  return false;
}

document.addEventListener("DOMContentLoaded", function () {
    const currentGenderNav = document.body.dataset.currentGenderNav || "header-group-home";
    const currentPath = window.location.pathname.toLowerCase();
    const strippedPath = currentPath.replace(/^\/[a-z]{2}(-[a-z]{2})?\//, '/'); // Remove subfolder (like /it/, /fr/)
    const productTags = window.productTags || []; // Ensure global productTags are available
    const productVendor = window.productVendor?.toLowerCase();
    const collectionGender = document.body.dataset.collectionGender?.toLowerCase();
    const pageHeaderGroup = document.body.dataset.pageHeaderGroup || '';
    const subfolderPath = window.location.pathname.split('/').filter(Boolean)[0];
    const isShopifyMarketPath = /^[a-z]{2}-[a-z]{2}$/.test(subfolderPath) ? `/${subfolderPath}` : '';
    const referrer = document.referrer;

    const genderHeaderMap = {
        "gender female": "header-group-women",
        "gender men":    "header-group-men",
    };

    /***********************************************************
     * 3) CART ATTRIBUTE UPDATE
     ************************************************************/
    function setCartAttribute(attribute, value) {
        // 1) Skip forced reload only if:
        //    - It's the user's FIRST visit, AND
        //    - They're on the root/localized root homepage
        if (!sessionStorage.getItem('visitedSiteBefore') && isRootOrLocalizedRoot()) {
            console.log("[setCartAttribute] First time on root => skipping forced reload");
            return;
        }

        // 2) Existing condition: if on root/localized root (regardless of first visit)
        //    => skip gender-nav logic and forced reload
        if (isRootOrLocalizedRoot()) {
            console.log("[setCartAttribute] On root/localized root => SKIP cart update & reload");
            return;
        }

        // Everything else remains unchanged
        if (isUpdating) return; 
        if (currentGenderNav === value) return; 
        if (sessionStorage.getItem('currentPage') === window.location.pathname) return;

        isUpdating = true;
        fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ attributes: { [attribute]: value } })
        }).then(() => {
            isUpdating = false;
            sessionStorage.setItem('currentPage', window.location.pathname);
            location.reload();
        });
    }

    /***********************************************************
     * 4) PAGE-LEVEL LOGIC
     ************************************************************/
    function handlePageLogic() {
        if (pageHeaderGroup && currentGenderNav !== pageHeaderGroup) {
            setCartAttribute("gender_nav", pageHeaderGroup);
        }
    }

    /***********************************************************
     * 5) DOLCE & GABBANA PRIORITY LOGIC
     ************************************************************/
    function handleDolceGabbanaPriority() {
        const normalizedVendor = productVendor?.toLowerCase();
        const expectedVendor = "dolce & gabbana";
        const isExternalEntry = !referrer || new URL(referrer).hostname !== location.hostname;

        // Respect active sessions for internal navigation
        if (!isExternalEntry && (currentGenderNav === "header-group-women" || currentGenderNav === "header-group-men")) {
            return false;
        }

        if (normalizedVendor === expectedVendor || productTags.some(tag => tag.toLowerCase() === expectedVendor)) {
            if (currentGenderNav !== "header-group-dolce-gabbana") {
                setCartAttribute("gender_nav", "header-group-dolce-gabbana");
            }
            return true;
        }

        if (collectionGender === "dolce-gabbana") {
            if (currentGenderNav !== "header-group-dolce-gabbana") {
                setCartAttribute("gender_nav", "header-group-dolce-gabbana");
            }
            return true;
        }

        // Updated path check
        if (strippedPath.includes(`/pages/${TRANSLATED_SLUGS.dg}`)) {
          if (currentGenderNav !== "header-group-dolce-gabbana") {
            setCartAttribute("gender_nav", "header-group-dolce-gabbana");
          }
          return true;
        }

        return false;
    }

    /***********************************************************
     * 6) PRODUCT-BASED LOGIC
     ************************************************************/
    function handleProductLogic() {
        if (!strippedPath.includes("/products/")) return;

        if (handleDolceGabbanaPriority()) return;

        if (currentGenderNav === "header-group-women" || currentGenderNav === "header-group-men") {
            return;
        }

        productTags.some(tag => {
            const targetHeaderType = genderHeaderMap[tag.toLowerCase()];
            if (targetHeaderType && currentGenderNav !== targetHeaderType) {
                setCartAttribute("gender_nav", targetHeaderType);
                return true; 
            }
        });
    }

    /***********************************************************
     * 7) COLLECTION-BASED LOGIC
     ************************************************************/
    function handleCollectionLogic() {
        if (!strippedPath.includes("/collections/")) return;

        if (currentGenderNav === 'header-group-women' || currentGenderNav === 'header-group-men') {
            return;
        }

        if (collectionGender === "women" && currentGenderNav !== "header-group-women") {
            setCartAttribute("gender_nav", "header-group-women");
        } else if (collectionGender === "men" && currentGenderNav !== "header-group-men") {
            setCartAttribute("gender_nav", "header-group-men");
        }

        // Add translated collection path check
  const collectionSlugs = {
    women: TRANSLATED_SLUGS.women,
    men: TRANSLATED_SLUGS.men
  };

  if (strippedPath.includes(`/collections/${collectionSlugs.women}`)) {
    setCartAttribute("gender_nav", "header-group-women");
  }
  if (strippedPath.includes(`/collections/${collectionSlugs.men}`)) {
    setCartAttribute("gender_nav", "header-group-men");
  }
      
    }

    /***********************************************************
     * 8) DIRECT ENTRY LOGIC
     ************************************************************/
    function handleDirectEntryLogic() {
        const isDirectEntry = !referrer || new URL(referrer).hostname !== location.hostname;

        if (isDirectEntry) {
            if (isRootOrLocalizedRoot()) {
                console.log("[handleDirectEntryLogic] On root/localized root => skip direct entry logic");
                return;
            }

            if (currentGenderNav === "header-group-women" || currentGenderNav === "header-group-men") {
                return;
            }

            let targetHeaderType = currentGenderNav;

            if (strippedPath.includes("/products/")) {
                targetHeaderType = productVendor === "dolce & gabbana"
                  ? "header-group-dolce-gabbana"
                  : productTags.includes("Gender Men")
                    ? "header-group-men"
                    : productTags.includes("Gender Female")
                      ? "header-group-women"
                      : currentGenderNav;
            }

            if (strippedPath.includes("/collections/") && collectionGender) {
                targetHeaderType = collectionGender === "men"
                  ? "header-group-men"
                  : collectionGender === "women"
                    ? "header-group-women"
                    : collectionGender === "dolce-gabbana"
                      ? "header-group-dolce-gabbana"
                      : currentGenderNav;
            }

            if (targetHeaderType && currentGenderNav !== targetHeaderType) {
                setCartAttribute("gender_nav", targetHeaderType);
            }
        }
    }

    /***********************************************************
     * 9) RUN THE LOGIC
     ************************************************************/
    handlePageLogic();
    handleDolceGabbanaPriority();
    handleProductLogic();
    handleCollectionLogic();
    handleDirectEntryLogic();
});


/***********************************************************
 * 10) NAVIGATION LOGIC FOR LINKS
 ************************************************************/
document.body.addEventListener("click", function (e) {
    const link = e.target.closest("a");
    if (!link || !link.href) return;

    if (isRootOrLocalizedRoot()) {
        console.log("[NavClick] On root/localized root => skipping gender-nav logic");
        return;
    }

    const url = new URL(link.href);
    const pathLower = url.pathname.toLowerCase();
    const strippedPath = pathLower.replace(/^\/[a-z]{2}(-[a-z]{2})?\//, '/');
    const subfolderPath = window.location.pathname.split('/').filter(Boolean)[0];
    const isShopifyMarketPath = /^[a-z]{2}-[a-z]{2}$/.test(subfolderPath) ? `/${subfolderPath}` : '';
    let headerType = document.body.dataset.currentGenderNav || "header-group-home";

    // Handle home button/logo click
    if (strippedPath === '/' || pathLower === `/${subfolderPath}/`) {
        e.preventDefault();

        const isSingleSubfolder = /^[a-z]{2}$/.test(subfolderPath);
        const isMultiSubfolder = /^[a-z]{2}-[a-z]{2}$/.test(subfolderPath);
        const basePath = isSingleSubfolder || isMultiSubfolder ? `/${subfolderPath}` : '';

        let targetPath = `${basePath}/`;
        if (headerType === "header-group-women") {
            targetPath = `${basePath}/pages/${TRANSLATED_SLUGS.women}`;
        } else if (headerType === "header-group-men") {
            targetPath = `${basePath}/pages/${TRANSLATED_SLUGS.men}`;
        } else if (headerType === "header-group-dolce-gabbana") {
            targetPath = `${basePath}/pages/${TRANSLATED_SLUGS.dg}`;
        }

        window.location.href = targetPath;
        return;
    }

      const headerTypeMap = {
        [TRANSLATED_SLUGS.women]: "header-group-women",
        [TRANSLATED_SLUGS.men]: "header-group-men",
        [TRANSLATED_SLUGS.dg]: "header-group-dolce-gabbana"
      };

    let newHeaderType = "";

    if (strippedPath.startsWith("/collections/") || strippedPath.startsWith("/pages/")) {
    const detectedSlug = Object.entries(headerTypeMap).find(([slug]) => {
      const slugSegment = `/pages/${slug}`;
      return strippedPath.startsWith(slugSegment) || strippedPath.includes(`/${slug}/`);
    });
    
    newHeaderType = detectedSlug ? detectedSlug[1] : "";
    }

    if (newHeaderType && newHeaderType !== headerType) {
        e.preventDefault();
        if (!isUpdating) {
            isUpdating = true;
            postData("/cart/update.js", { attributes: { gender_nav: newHeaderType } }).then(() => {
                isUpdating = false;
                window.location.href = link.href;
            });
        }
    }
});
